import { render, staticRenderFns } from "./LocalisationArticlesMobileModal.vue?vue&type=template&id=7465ffef&"
import script from "./LocalisationArticlesMobileModal.vue?vue&type=script&lang=ts&"
export * from "./LocalisationArticlesMobileModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports